'use client';

import dynamic from 'next/dynamic';

import { SubMenuBase } from '@/app/components/layouts/top-navigation/sub-menu/base';
import type { NavItemType } from '@/app/types/top-navigation';

const SubMenuLcv = dynamic(
  () =>
    import('@/app/components/layouts/top-navigation/sub-menu/lcv').then(
      (mod) => mod.SubMenuLcv
    ),
  {
    ssr: false,
  }
);

const SubMenuCv = dynamic(
  () =>
    import('@/app/components/layouts/top-navigation/sub-menu/cv').then(
      (mod) => mod.SubMenuCv
    ),
  {
    ssr: false,
  }
);

interface SubMenuRenderLayoutProps {
  activeItem?: NavItemType;
  isDesktop?: boolean;
  onReady?: () => void;
  onClose?: () => void;
}

export const SubMenuRenderLayout = ({
  activeItem,
  isDesktop = false,
  onReady,
  onClose,
}: SubMenuRenderLayoutProps) => {
  if (!activeItem) return null;

  if (activeItem.modelMenu === 'cv') {
    return <SubMenuCv isDesktop={isDesktop} onReady={onReady} />;
  }

  if (activeItem.modelMenu === 'lcv') {
    return <SubMenuLcv isDesktop={isDesktop} onReady={onReady} />;
  }

  return (
    <SubMenuBase
      items={activeItem.items}
      as={activeItem.as}
      isDesktop={isDesktop}
      onReady={onReady}
      onClose={onClose}
    />
  );
};
